<div class="container-fluid new-signaling">

  <div [hidden]="sent">

    <div class="row signalings-title">
      <div class="col-12 d-flex align-items-center">
        <a backButton>
          <i class="icon-edponline-Bra-073 rotate-90 font-size-24 color-black"></i>
        </a>
      </div>
      <div class="col-12 d-flex justify-content-center signaling-text">
        <span class="pb-5 pr-2">{{'edp.emarket.nova.sinalizacao.sinalizar' | translate}}</span>
        <span>{{'edp.emarket.nova.sinalizacao.omip' | translate}}</span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-md-8 offset-md-2 px-4">
        <form [formGroup]="signalingForm" (ngSubmit)="onSubmit()">

          <div class="form-group mb-0">
            <label for="name" class="mb-0">
              {{'edp.emarket.nova.sinalizacao.tipo.produto' | translate}}
            </label>
            <mat-form-field class="col-12 px-0 pt-1" floatLabel="never">
              <input matInput [matAutocomplete]="auto" placeholder=" {{'edp.emarket.nova.sinalizacao.placeholder' | translate}}" formControlName="productType">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" class="new-alert-autocomplete">
                @for (option of filteredOptions | async; track option) {
                  <mat-option [value]="option">
                    {{option.nm}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="form-group form-value-container">
            <label for="address" class="mb-0">
              {{'edp.emarket.detalhe.valor' | translate}}
            </label>
            <mat-form-field floatLabel="never" class="pt-1">
              <mat-label class="select-text">%</mat-label>
              <mat-select panelClass="edit-alert-variation" formControlName="percValue">
                <mat-option disabled>
                  <div class="d-flex justify-content-between align-items-center pt-2">
                    % <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
                  </div>
                </mat-option>
                @for (val of percentageValues; track val) {
                  <mat-option value="{{val}}">{{val}}%</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="row w-100 ml-1">
            <div class="col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-0">
              <button class="bg btn w-100 mt-3" type="submit" id="btn-submit">
                <span class="bg-text">{{'edp.emarket.detalhe.avancar' | translate}}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  @if (sent) {
    <div>
      <div class="row d-flex justify-content-center">
        <div class="signaling-confirm margin-top-74">
          <span class="d-block">{{'edp.emarket.nova.sinalizacao.confirmar.sinalizacao' | translate: {'f.percValue.value': f.percValue.value} }}</span>
          <span>{{ selectedMarket }}</span>
          <span>?</span>
        </div>
      </div>
      <div class="row px-4 pt-1 margin-top-33">
        <div class="col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-4">
          <button class="btn bg w-100" (click)="confirm()" [disabled]="pending" id="btn-confirm">
            @if (pending) {
              <span class="spinner-border" style="width: 1.25rem; height: 1.25rem;" role="status" aria-hidden="true"></span>
            } @else {
              <span class="bg-text">{{'edp.emarket.detalhe.confirmar' | translate}}</span>
            }
          </button>
        </div>
      </div>
      <div class="row mt-3 px-4">
        <div class="col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-4">
          <button class="btn bg-2 w-100" routerLink="/signalings" id="btn-cancel">
            <span class="bg-text">{{'edp.emarket.detalhe.cancelar' | translate}}</span>
          </button>
        </div>
      </div>
    </div>
  }
</div>
